import ChargeHelper from 'features/Charge/chargeHelper';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

DialogMovePointView.propTypes = {
  title: PropTypes.string,
  contentEl: PropTypes.element,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  iconEl: PropTypes.element,
  chargePointDetail: PropTypes.object,
};

function DialogMovePointView({
  title = '',
  contentEl,
  onCancel,
  onConfirm,
  iconEl,
  chargePointDetail,
}) {
  // MARK: ---- PROPERTIES ----
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [selectedChargeStation, setSelectedChargeStation] = useState(null);
  useEffect(() => {
    if (Utils.isValid(chargePointDetail?.stationId)) {
      ChargeHelper.API.getChargeStationDetail(chargePointDetail?.stationId).then((data) => {
        setSelectedChargeStation({
          id: data?.stationId,
          name: data?.name,
          item: data,
          address: ChargeHelper.Utils.getChargeStationFullAddress(data),
        });
      });
    }
  }, [chargePointDetail]);

  // MARK: ---- METHODS ----
  const handleSubmit = () => {
    setReadyToValidate(true);
    if (!Utils.isValid(selectedChargeStation)) {
      ToastHelper.showError('Vui lòng chọn trạm sạc');
      return;
    }
    const stationId = selectedChargeStation?.id;
    if (onConfirm) {
      onConfirm(stationId);
    }
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-5">
        {/* icon */}
        {iconEl && <div className="mb-4">{iconEl}</div>}

        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>{title}</span>
        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>{contentEl}</span>

        <div className="w-100 mt-4">
          {UIHelper.buildFormLabel('Trạm sạc muốn chuyển tới', true)}
          <CustomDropdown2
            id="station"
            name="station"
            toggleElement={
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${readyToValidate && !Utils.isValid(selectedChargeStation) ? 'button-invalid' : ''
                  }`}
                type="button"
              >
                {selectedChargeStation?.name ?? 'Chọn trạm sạc'}
              </button>
            }
            selectedValue={selectedChargeStation}
            subTitleType="address"
            dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
            getSubItems={async (item) => {
              return ChargeHelper.API.requestGetChargeStationList({
                page: item?.page || 0,
                limit: 10,
                q: item?.q || '',
              }).then((data) => {
                return {
                  values: data.chargeStations?.map((station) => ({
                    id: station?.stationId,
                    name: station?.name,
                    item: station,
                    address: ChargeHelper.Utils.getChargeStationFullAddress(station),
                  })),
                  total: data.total,
                };
              });
            }}
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            dropdownMenuClassName="overflow-auto w-100"
            onChange={(value) => {
              setSelectedChargeStation(value);
            }}
            isDropdownForm={true}
            titleSearchable={true}
            searchable={true}
            searchFormClassName="mx-3 my-1 search-form-border"
            ignoreConfirmClick={true}
            defaultValue={{
              name: 'Trạm sạc',
              role: 'STATION',
            }}
            footerEl={
              <div
                className="p-4 position-sticky sticky-bottom bg-white"
                style={{
                  borderTop: `1px solid ${AppColors.gray[300]}`,
                }}
              >
                {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                  setSelectedChargeStation(null);
                })}
              </div>
            }
          />
        </div>
      </div>
      {/* footer */}
      <div
        className="d-flex align-items-center gap-3 px-4 py-3 w-100"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Di chuyển', handleSubmit, null, true)}
      </div>
    </div>
  );
}

export default DialogMovePointView;
